// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2asVO","content":"styles_content__20PSb"};